// Versión del sistema NEUROMATEMÁTICAS JASQ®.
// Cambiar APP_VERSION en cada release/iteración para que los usuarios
// puedan verificar visualmente que están usando la build actualizada.
//
// Formato: HITO.FASE.ITERACIÓN (YYYY.MM.DD) — etiqueta opcional.

export const APP_VERSION = "5.7.5";
export const APP_RELEASE_TAG = "Logo HD en toda la plataforma, resumen ejecutivo con metas y notas, guardado de perfiles reforzado, buscador de preguntas y recuperación de grabaciones";
export const APP_BUILD_DATE = "2026-11-03";

export const APP_VERSION_LABEL = `v${APP_VERSION} · ${APP_RELEASE_TAG}`;
